export default {
  replySent: "Risposta inviata! Notifica email inviata al venditore",
  internalNoteAdded: "Nota interna aggiunta",
  sendMessageError: "Impossibile inviare il messaggio",
  ticketMarked: "Ticket contrassegnato come {{label}}",
  updateStatusError: "Impossibile aggiornare lo stato",
  priorityUpdated: "Priorità aggiornata",
  updatePriorityError: "Impossibile aggiornare la priorità",
} as const;
